class EnvConfig {
  constructor() {
    this.apiUrl = window.envConfig ? window.envConfig.apiUrl : 'https://raapi-local.roomalert.com';
    this.raaUrl = window.envConfig ? window.envConfig.raaUrl : 'https://account-local.roomalert.com';
    this.wsUrl = window.envConfig ? window.envConfig.wsUrl : 'ws://localhost:8109';
    this.raaToken = '';
    this.useMockSession = false;
    this.googleMapsApiKey = window.envConfig ? window.envConfig.googleMapsApiKey : '';
  }
}

const envConfig = new EnvConfig();
export { EnvConfig };
export default envConfig;
